<template>
  <div class="fullpage">
    <div class="searchBox" v-if="type == 0">
      <el-input style="width: 30%;margin-right: 10px;" clearable v-model="frameNum" :placeholder="`${$t('menu.FrameNumber')}/${$t('menu.EngineNumber')}`"></el-input> 
      <el-button plain @click="querySearch">{{ $t('menu.search') }}</el-button>
    </div>
    <div class="basicInformation">
      <div class="title">
        <div class="name">{{$t('menu.Basicinformation')}}</div>
      </div>
      <div class="Info" v-if="type == 2 || type == 1">
        <div class="infoItem">
          <div class="name">{{ $t('menu.ClaimNumber') }}</div>
          <div class="infoData">{{ carInfo.co.claimNumber }}</div>
        </div>
        <div class="infoItem" v-if="type == 2">
          <div class="name">{{ $t('menu.State') }}</div>
          <div class="infoData">{{staue.filter(e=>e.id == carInfo.co.status).length>0 ?staue.filter(e=>e.id == carInfo.co.status)[0].name:carInfo.co.status}}</div>
        </div>
      </div>
      <div class="Info">
        <div class="infoItem">
          <div class="name">{{ $t('menu.ProductName') }}</div>
          <div class="infoData" v-if="type == 0">{{  filterCarModels(carInfo.co.params!==undefined? carInfo.co.params.mcVersion.mcSeriesModel:'') }}</div>
          <div class="infoData" v-if="type == 2 || type == 1">{{ iszh == 'zh' ? carInfo.co.motorName :  carInfo.co.motorNameEn}}</div>
          <div v-if="showInfo">——</div>
        </div>
        <div class="infoItem">
          <div class="name">{{ $t('menu.FrameNumber') }}</div>
          <div class="infoData">{{ carInfo.co.chassisNumber || carInfo.co.vin }}</div>
          <div v-if="showInfo">——</div>
        </div>
        <div class="infoItem">
          <div class="name">{{ $t('menu.EngineNumber') }}</div>
          <div class="infoData">{{ carInfo.co.engineNo }}</div>
          <div v-if="showInfo">——</div>
        </div>
        <div class="infoItem">
          <div class="name">{{ $t('menu.State') }}</div>
          <div class="infoData">{{staue.filter(e=>e.id == carInfo.co.status).length>0 ?staue.filter(e=>e.id == carInfo.co.status)[0].name:carInfo.co.status}}</div>
       
          <div v-if="showInfo">——</div>
        </div>
        <div class="infoItem">
          <div class="name">{{ $t('menu.SaleDate') }}</div>
          <div class="infoData" >{{ carInfo.co.salesDate }}</div>
          <div v-if="showInfo">——</div>
        </div>
  
        <div class="infoItem">
          <div class="name">{{ $t('menu.Dealer') }}</div>
          <div class="infoData">{{ carInfo.co.sellingDealerName }}</div>
          <div v-if="showInfo">——</div>
        </div>
      </div>
    </div>
    <div class="compensateInfo">
      <div class="title">
   
        <div class="name">{{ $t('menu.baoyangxinxx') }}</div>
      </div>
      <div v-if="showInfo" class="beforeShowInfo">
        {{showinfoMsg}}
      </div>
      <div v-else>
        <div class="infoItemOne">
          <div class="infoItemOneItem">
            <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.wbdylxr') }}</div>
            <div class="inputBox">
              <el-input v-model="carInfo.co.userName" :placeholder="$t('menu.Customer')" v-if="type == 0 || type == 1"></el-input>
              <div v-if="type == 2">{{carInfo.co.userName	}}</div>
            </div>
          </div>
          <div class="infoItemOneItem">
            <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span>{{ $t('menu.wbdylxfs') }}</div>
            <div class="inputBox">
              <el-input v-model="carInfo.co.userPhone"  :placeholder="$t('menu.wbdylxfs')" v-if="type == 0 || type == 1"></el-input>
              <div v-if="type == 2">{{carInfo.co.userPhone}}</div>
            </div>
          </div>

          <div class="infoItemOneItem">
            <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.wbdyfwxm') }}
            </div>
            <div class="inputBox">
              <el-select v-model="carInfo.co.serviceType" :placeholder="$t('menu.wbdyfwxm')" clearable v-if="type == 0 || type == 1">
                <!-- <el-option label="维修" value="wx"  ></el-option> -->
                <el-option :label="$t('menu.baoyang')" value="by"  ></el-option>
              </el-select>
              <div v-if="type == 2 ">
                <!-- <span v-if="carInfo.co.serviceType=='wx'">维修</span> -->
                 <span v-if="carInfo.co.serviceType=='by'">{{ $t('menu.baoyang') }}</span>
              </div>
            </div>
          </div>
         
          <div class="infoItemOneItem">
            <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.Mileage')}}(km)</div>
            <div class="inputBox">
              <el-input v-model="carInfo.co.mileage" :placeholder="$t('menu.Enter')" v-if="type == 0 || type == 1"></el-input>
              <div v-if="type == 2">{{carInfo.co.mileage}}</div>
            </div>
          </div>
       
        
        </div>
        <!-- <div class="infoItemTwo">
          <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{
            $t('menu.ProblemDescription')
          }}</div>
          <el-input type="textarea" :rows="2"  :placeholder="$t('menu.Enter')" v-model="carInfo.co.faultDesc"
            v-if="type == 0 || type == 1" ></el-input>
          <div v-if="type == 2">{{carInfo.co.faultDesc}}</div>
        </div> -->
        
        <!-- <div class="infoItemTwo">
          <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.Solution') }}
          </div>
          <el-input type="textarea" :rows="2"  :placeholder="$t('menu.Enter')" v-model="carInfo.co.repairPlan"
            v-if="type == 0 || type == 1"></el-input>
          <div v-if="type != 0 && type != 1">{{carInfo.co.repairPlan}}</div>
        </div> -->
        <div class="infoItemTwo"  v-if="carInfo.co.status==59">
          <div class="name"><span style="color: red;">*</span>{{ $t('menu.Reasons') }}
          </div>
         
          <div >{{carInfo.co.remarks }}</div>
        </div>
      </div>
    </div>
    <div class="compensateDetail" v-if="!showInfo">
      <div class="title">
        <div class="nameList">
          <div class="nameItem" :class="active == 1 ? 'acti' : ''" @click="changeActive(1)">{{ $t('menu.wbdymx') }}</div>
          </div>
      </div>
      <!-- 明细 -->
      <div class="detail" v-if="active == 1">
        <!-- <div class="typeTitle">
          <div class="name"><span style="color: red;">*</span> {{ $t('menu.wbdysypj') }}</div>
        </div>
        <el-button plain @click="addParts" v-if="type == 0 || type == 1" style="margin-bottom: 10px;">{{ $t('menu.AddTo') }}</el-button>
        <el-table :data="carInfo.moParts" border style="width: 100%">
          <el-table-column  type="index" :label="$t('menu.NO')" width="50"></el-table-column>
          <el-table-column prop="partNumber" :label="$t('menu.PartCode')" min-width="120"></el-table-column>
          <el-table-column prop="partName" :label="$t('menu.PartName')" min-width="120">
            <template slot-scope="scope">{{ iszh=='zh' ? scope.row.partName : scope.row.partNameEn }}</template>
          </el-table-column>
          
          <el-table-column prop="unitPrice" :label="$t('menu.UnitPrice')" min-width="120" v-if="type == 2"></el-table-column>
          <el-table-column :label="$t('menu.Quantity')" min-width="80" v-if="type == 0 || type == 1">
            <template slot-scope="scope">
              <el-input v-model="scope.row.minPurchaseQuantity"  @input="sumMoney(scope.row)"></el-input>
            </template>
          </el-table-column>
        
          <el-table-column prop="amount" :label="$t('menu.Quantitya')" min-width="80" v-if="type == 2"></el-table-column>
          <el-table-column :label="$t('menu.Operation')" width="150" v-if="type == 0 || type == 1">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="deleteCoparts(scope.$index, scope.row)">{{ $t('menu.Delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table> -->

        <!-- 附件 -->
        <!-- <div class="detail" v-if="active == 2"> -->
        <div class="typeTitle">
          <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{$t('menu.Attachment')}}</div>
        </div>
        <el-upload action="#" :multiple="true"   list-type="icon" :on-preview="handlePictureCardPreview" :http-request="uploadFile" :before-upload="beforeAvatarUpload" 
          :file-list="fileList" v-if="type == 0 || type == 1">
          <el-button size="small" type="primary">{{$t('menu.Uploadfiles')}}</el-button>
          <div slot="tip" class="el-upload__tip">{{$t('menu.qingshangchaunss')}}</div>

          <div slot="file" slot-scope="{file}">
              <img @click="filedialogVisiblea(file)" style="width: 100px;height: 100px;border-radius: 15px;" class="el-upload-list__item-thumbnail" :src="showFile(file)">
              <span class="el-upload-list__item-actions">
                <a :href="file.url" style="text-decoration:auto;color: #000;cursor: pointer;"  >
                  {{ $t('menu.Download') }}
                </a>
               <span style="cursor: pointer;"  @click="handleRemove(file)" >
                
                {{ $t('menu.Delete') }}
               </span>
               <!-- <span v-if="!disabled" @click="handleRemove(file)" class="el-upload-list__item-delete">
                 <i class="el-icon-delete"></i>
               </span> -->
             </span>
            </div>


        </el-upload>
        <div  v-if="type == 2" style="display: flex;">
          <div v-for="(item,index) in JSON.parse(carInfo.co.imageData)" :key="index"  style="border: 1px solid #f2f2f2; padding: 10px;margin-right: 10px;">
     
          <img @click="filedialogVisiblea(item)" style="width: 100px;height: 100px;border-radius: 15px;" class="el-upload-list__item-thumbnail" :src="showFile(item)">
            
              <div style="text-align: center;">
                <div>{{ item.name }}</div>
               <div>
                <a :href="item.url" style="text-decoration:auto;color: #000;cursor: pointer;"  >
                  {{ $t('menu.Download') }}
                </a>
              </div>
              </div>
            

          </div>
        </div>
      </div>
      <!-- 索赔记录 -->
      <div class="detail" v-if="active == 3">
        <el-table :data="carInfo.hisCos" border style="width: 100%">
          <el-table-column prop="claimNumber" :label="$t('menu.ClaimNumber')" min-width="80"></el-table-column>
          <el-table-column :label="$t('menu.Vehicle')" min-width="80">
            <template slot-scope="scope">{{ iszh == 'zh' ? scope.row.motorName : scope.row.motorNameEn}}</template>
          </el-table-column>
          <el-table-column prop="serviceType" :label="$t('menu.wbdyfwxm')" min-width="80">
            <template slot-scope="scope">
               <span v-if="scope.row.serviceType=='wx'">{{$t('menu.weix')}}</span>
                 <span v-if="scope.row.serviceType=='by'">{{$t('menu.baoyang')}}</span>
           
            </template>
          </el-table-column>
          <el-table-column prop="mileage" :label="$t('menu.Mileage')" min-width="80"></el-table-column>
          <el-table-column prop="currencyType" :label="$t('menu.Currency')" min-width="80"></el-table-column>
          <el-table-column prop="claimAmount" :label="$t('menu.ClaimAmount')" min-width="80"></el-table-column>
          
        </el-table>
      </div>
      <!-- 操作记录 -->
      <div class="detail" v-if="active == 4">
        <el-table :data="carInfo.coOperationLogs" border style="width: 100%">
          <el-table-column prop="actionTime" :label="$t('menu.Timecaozuo')"  min-width="80"></el-table-column>
          <el-table-column prop="actionUserName" :label="$t('menu.Operator')" min-width="80"></el-table-column>
          <el-table-column prop="actionEvent" :label="$t('menu.OperationContent')" min-width="80"></el-table-column>
          <el-table-column prop="remarks" :label="$t('menu.Remarks')" min-width="80"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="subBox" v-if="!showInfo">
      <!-- <div class="totalMoney">合计： <span style="color: red;">$ 20.23</span></div> -->
      <div class="butto">
        <el-button type="primary" @click="submit" v-if="type == 0">{{$t('menu.Submitsuopei')}}</el-button>
        <el-button type="primary" @click="updateMyCo" v-if="type == 1"> {{ $t('menu.Save') }} </el-button>
        <el-button plain @click="modify" v-if="type == 2 && carInfo.co.status == 10">{{ $t('menu.Modify') }}</el-button>
        <el-button plain @click="cancelMyCo" v-if="type == 2 && carInfo.co.status == 10">{{$t('menu.Cancelsuopei') }}</el-button>
        <el-button type="primary" v-if="type == 2 && carInfo.co.status == 60" @click="modify">{{ $t('menu.Modify') }}</el-button>
        <el-button type="primary" v-if="type == 2 && carInfo.co.status == 59" @click="modify">{{ $t('menu.Modify') }}</el-button>
        <el-button plain @click="cancelMyCo" v-if="type == 2 && carInfo.co.status == 59">{{$t('menu.Cancelsuopei') }}</el-button>
        <el-button  v-if="type == 0 || type == 1" @click="cancel"> {{ $t('menu.Cancel') }} </el-button>
      </div>
    </div>

    <!--添加配件  -->
    <el-dialog :title="$t('menu.AddParts')" :visible.sync="dialogVisiblePart" v-if="dialogVisiblePart" width="800px" @close="ccac" :close-on-click-modal="false">
      <div class="partBox">
        <div class="searchBox">
          <el-input v-model="searchKey" :placeholder=" $t('menu.Enter') "></el-input>
          <el-button plain @click="pageQueryPartList">{{ $t('menu.search') }}</el-button>
        </div>
        <el-table :data="partList" border style="width: 100%" @selection-change="handleSelectionChange" height="500">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="partNumber" :label="$t('menu.PartCode')" min-width="80"></el-table-column>
          <el-table-column :label="$t('menu.PartName')" min-width="80">
            <template slot-scope="scope">
              {{ iszh == 'zh' ? scope.row.partName : scope.row.partNameEn }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('menu.Partcategory')" min-width="80">
            <template slot-scope="scope">
              {{ iszh == 'zh' ? scope.row.partCategory.categoryName : scope.row. partCategory.categoryNameEn }}
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$t('menu.Currency')" min-width="80">
            <template slot-scope="scope">{{ currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('menu.UnitPrice')" min-width="80">
            <template slot-scope="scope">{{ currency == 'CNY' ? scope.row.purchasePriceCny : currency == 'EUR' ? scope.row.purchasePriceEur : scope.row.purchasePriceUsd }}</template>
          </el-table-column> -->
        </el-table>
        <div class="buttBox">
          <el-button type="primary" @click="getpartList">{{$t('menu.Confirm')}}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 文件预览 -->
    <el-dialog :visible.sync="filedialogVisible" :title="srtitle" v-if="filedialogVisible"  width="70%" style="">
      <iframe :src="filedialogImageUrl" frameborder="0" style="width: 100%;height:800px;"></iframe>
    </el-dialog>
    <!-- 提交成功弹窗 -->
    <el-dialog :visible.sync="centerDialogVisible" width="30%" center :close-on-click-modal="false">
      <div class="img"><img src="../../assets/images/ck_tg.png" alt=""></div>
      <div style="width: 100%;text-align: center;margin: 30px 0">{{$t('menu.Success')}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="continueToApply">{{$t('menu.Continue')}}</el-button>
        <el-button type="primary" @click="viewOrders">{{$t('menu.Viewtheorder')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { pageQueryPartList, pageQueryVin, cancelMyCo,getInfo,mcVehicleOfDealerList, upload, pageQuerySa,listAccType,querytype,gbquerytype,submitCoDto,submoOfDealer,mcVehicleOfDealerLista,pageQueryParta,listMcSeriesModels,getMyCoDto,updateMyCo } from '../../api/api'
export default {
  data () {
    return {
      type: 0, //类型（0-新增，1-修改，2-详情(审核中、已取消、待接收)  3-重新提交）
      iszh:sessionStorage.getItem('i18n'),
      titleList:[],
      cartypelist:[],
      active: 1,
      dialogVisiblePart: false,
      centerDialogVisible: false,
      currency:sessionStorage.getItem('shbz'), //币种
      showInfo:true,
      showinfoMsg:this.$t('menu.Pleaseentertheframe'),
      searchKey: '',
      amount:0,
      frameNum: '', //发动机号
      carList: [],
      carInfo: {
        co:{
          userName:'',
          userPhone:'',
          serviceType: '', //索赔类型
          mileage: '', //行驶里程
          faultDesc: '', //故障描述
         
          repairPlan: '', //解决方案
        },
        moParts: [],//索赔配件
      },
      coLabours: [
        {
          labourName: '',//名称
          //币种
          unitPrice: '',//标准工时费
          labourHours: '',//工时
          labourCost: '',//工时费
          needClaim: '',//支持索赔
        }
      ],//索赔工时
      partList: [],//配件列表
      filedialogImageUrl: '',//文件预览地址
      titleLista:[],
      filedialogVisible: false,
      fileList: [],//上传文件列表
      selectpart:[],
      gb:[],
      aeera: [],
      srtitle:'',
      acbc:[],
      staue: [
      {
          name: this.$t('menu.All'),
          num: 0,
          id: ''
        },
        {
          name: this.$t('menu.Unread'),
          num: 0,
          id: 10
        },
      
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '20'
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '29'
        },
        {
          name:this.$t('menu.Underreview'),
          num: 0,
          id: '30'
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '39'
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '40'
        },
        {
          name: this.$t('menu.Underreview'),
          num: 0,
          id: '49'
        },
        {
          name: this.$t('menu.Approved'),
          num: 0,
          id: '50'
        },
        {
          name: this.$t('menu.Rejected2'),
          num: 0,
          id: '59'
        },
        {
          name: this.$t('menu.Cancelled'),
          num: 0,
          id: '60'
        },
      ],
      jxc:[],
      acclist:[],
     

    }
  },
  filters:{
    NumFormat(value) {
      if (!value) return '0.00';
      // 将数值截取，保留两位小数
      value = Number(value).toFixed(2);
      // 获取整数部分
      const intPart = Math.trunc(value);
      // 整数部分处理，增加,
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      // 预定义小数部分
      let floatPart = '.00';
      // 将数值截取为小数部分和整数部分
      const valueArray = Number(value)
          .toString()
          .split('.');
      if (valueArray.length === 2) {
          // 有小数部分
          floatPart = valueArray[1].toString(); // 取得小数部分
          return intPartFormat + '.' + floatPart;
      }
      return intPartFormat + floatPart;
    }

  },
 
  mounted () {
    this.acc()
    this.infoaa()
    this.getQuerytype()
    this.aeer()
    this.gbquerytype()
    this.gbquerytypea()
    this.listMcSeriesModel()
    if(this.$route.query.type) {
      this.type= this.$route.query.type
      if(this.type == 2){
        this.showInfo = false
        this.getMyCoDto(this.$route.query.id)
      }
    }
  },
  watch:{
    fileList(newV,oldV){
      if(JSON.stringify(newV) != this.carInfo.co.imageData){
        let v =[]
        this.fileList.forEach((e,i)=>{
          let  bbb ={
            name:e.name,
            url:e.url,
            deleted:false
          }
         v.push(bbb)
        })
        this.carInfo.co.imageData = JSON.stringify(v)
      }
    },
    '$route': {
      handler (newVal, old) {
        console.log(old,88888888);
        if(old === undefined){
        } else {
          location.reload()
        }
        
      },
      immediate: true
    }
  },
  methods: {
    

    async acc () {
      let param = new URLSearchParams();
      const { data: res } = await listAccType(param)
    this.acclist  = res.data
   

    },
    async infoaa () {
      let param = new URLSearchParams();
      const { data: res } = await getInfo(param)
      

      this.acclist.forEach(e => {
        if (e.id == res.user.dealers[0].accTypeIdLs&&res.uesr.platform=='2') {
          
          sessionStorage.setItem("shbz", e.currencyType)
   

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
          if (e.id == res.user.dealers[0].accTypeIdSh&&res.uesr.platform!=='2') {
          
          sessionStorage.setItem("shbz", e.currencyType)
   

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
      })
    },
    showFile(file){
      console.log(456,file)
      
      const isImage = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length)
      if(isImage=='png'||isImage=='jpg'||isImage=='jpeg'){
        return file.url;
      }
      if(isImage=='pdf'){
        return require('@/assets/images/pdf.jpeg')
      }
      if(isImage=='txt'){
        return require('@/assets/images/txt.webp')
      }
      if(isImage=='doc'||isImage=='docx'){
        return require('@/assets/images/word.jpeg')
      }
      if(isImage=='xls'||isImage=='xlsx'){
        return require('@/assets/images/xlsx.webp')
      }

    },
    base64Encode(e){
  var rv;
  rv = encodeURIComponent(e);
  rv = unescape(rv);
  rv = window.btoa(rv);
  return rv;
},
    filedialogVisiblea(str){
      console.log(str);
      this.srtitle=str.name
      let b = str.name.substring(str.name.lastIndexOf(".") + 1, str.name.length);

      // this.aurl='https://view.officeapps.live.com/op/view.aspx?src=https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
      this.filedialogImageUrl = 'https://view.bendamoto.com/onlinePreview?url='+encodeURIComponent(this.base64Encode(str.url))



 
      this.filedialogVisible = true
    },
    changeActive (e) {
      this.active = e
    },
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();
      const { data: res } = await listMcSeriesModels(param);
      this.cartypelist = res.data;
    },
    filterCarModels(m){
      if(m == '') return ''
      if(this.cartypelist.some(e=>e.id == m)){
        return this.iszh == 'zh' ? this.cartypelist.filter(e=>e.id == m)[0].seriesModel : this.cartypelist.filter(e=>e.id == m)[0].seriesModelEn
      } else {
        return m
      }
    },
    
    deleteCoparts(index,row){
      let a  = this.carInfo.moParts[index]
      a.deleted=true
      this.acbc.push(a)
      this.carInfo.moParts.splice(index,1)
      this.amount=0
      
      this.carInfo.moParts.forEach(e=>{
        this.amount = this.amount + Number(this.currency == 'CNY' ? e.purchasePriceCny : this.currency == 'EUR' ? e.purchasePriceEur : e.purchasePriceUsd) * Number(e.minPurchaseQuantity)
      })
    },

    sumMoney(z){
      this.amount = 0
      let a = this.carInfo.moParts
      this.carInfo.moParts=[]
      a.forEach((e,i)=>{
        if(e.id == z.id){
          this.$set(a[i], "minPurchaseQuantity", e.minPurchaseQuantity);
          // a[i].minPurchaseQuantity=e.minPurchaseQuantity
        }
        this.amount = this.amount + Number(this.currency == 'CNY' ? e.purchasePriceCny : this.currency == 'EUR' ? e.purchasePriceEur : e.purchasePriceUsd) * Number(e.minPurchaseQuantity)
      })
      this.carInfo.moParts=a
      console.log( this.carInfo.moParts);
      
     
    },
    //车架号查询
    querySearch () {
      let params = 'searchValue=' + this.frameNum
      mcVehicleOfDealerLista(params).then(res=>{
        if(res.data.total !== 0){
          this.carInfo.co= {...this.carInfo.co,...res.data.rows[0]}
          this.carInfo.co.engineNo = this.carInfo.co.engineNumber
          this.carInfo.co.sellingTime = this.carInfo.co.salesDate
          this.carInfo.co.userName = this.carInfo.co.customerName
          this.carInfo.co.imageData = ''
          delete this.carInfo.co.status
          this.showInfo = false
        }else{
          this.showinfoMsg = this.$t('menu.Novehiclemodelinformation') 
        }
      })
    },
    ccac(){
      console.log(123, this.searchKey);
      this.searchKey=''
      console.log(123, this.searchKey);
    },
    //我的理赔单详情
    getMyCoDto (id) {
      getMyCoDto('coId=' + id).then(res => {
        this.carInfo = res.data.data
        this.carInfo.moParts.forEach((e,i)=>{
          this.$set(e, "minPurchaseQuantity",  e.quantity);
       
      })
      console.log(1221112,this.carInfo);
      
        this.fileList = JSON.parse(res.data.data.co.imageData)
      })
    },
    NumFormat2(value) {
      if (!value) return '0.00';
      // 将数值截取，保留两位小数
      value = Number(value).toFixed(2);
      // 获取整数部分
      const intPart = Math.trunc(value);
      // 整数部分处理，增加,
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      // 预定义小数部分
      let floatPart = '.00';
      // 将数值截取为小数部分和整数部分
      const valueArray = Number(value)
          .toString()
          .split('.');
      if (valueArray.length === 2) {
          // 有小数部分
          floatPart = valueArray[1].toString(); // 取得小数部分
          return intPartFormat + '.' + floatPart;
      }
      return intPartFormat + floatPart;
    },
    //提交
    submit () {
      // if(this.carInfo.moParts.length<1){
      //   this.$message({
      //     message: '请添加配件',
      //     type: 'warning'
      //   });
      //   return
      // }
      this.carInfo.moParts.forEach((e,i)=>{
        e.partId = e.id
        this.carInfo.moParts[i].id=null
        e.quantity = e.minPurchaseQuantity
        e.amount=Number(this.currency == 'CNY' ? e.purchasePriceCny : this.currency == 'EUR' ? e.purchasePriceEur : e.purchasePriceUsd) * Number(e.minPurchaseQuantity)
      })
   
      
      let data= {
      
          userName:this.carInfo.co.userName,
          userPhone:this.carInfo.co.userPhone,
          serviceType:this.carInfo.co.serviceType,
          mileage:this.carInfo.co.mileage,
          faultDesc:this.carInfo.co.faultDesc,
          repairPlan:this.carInfo.co.repairPlan,
           moParts:this.carInfo.moParts,
          imageData:this.carInfo.co.imageData,
          engineNo:this.carInfo.co.engineNo,
          vin:this.carInfo.co.chassisNumber,
          status:1,
       
       
       
      }
      submoOfDealer(data).then(res=>{
        console.log(111111111,res);
        
        if(res.data.code == 200){
            this.$message({
          message: '修改成功',
          type: 'success'
        });
          this.centerDialogVisible = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //修改 tijiao
    updateMyCo(){
      // updateMyCo().then(res=>{

      // })
      this.carInfo.moParts.forEach((e,i)=>{
        if(e.partId==null&&e.partId==undefined){
          e.partId = e.id
          this.carInfo.moParts[i].id=null
        }
        e.quantity = e.minPurchaseQuantity
      })
      this.acbc.forEach(zz=>{
        this.carInfo.moParts.push(zz)
      })
      submitCoDto(this.carInfo).then(res=>{
        if(res.data.code == 200){
          this.centerDialogVisible = true
             this.$message({
          message: '修改成功',
          type: 'success'
        });
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    modify(){
      this.type = 1
      this.fileList= JSON.parse( this.carInfo.co.imageData );
      this.amount=this.carInfo.coPartAmount
      this.carInfo.moParts.forEach((e,index)=>{
        if(e.quantity){
          e.minPurchaseQuantity = e.quantity
          this.$set(this.carInfo.moParts,index,e)
          if(this.currency == 'CNY'){
            e.purchasePriceCny = e.unitPrice
            this.$set(this.carInfo.moParts,index,e)
          } else if(this.currency == 'EUR'){
            e.purchasePriceEur = e.unitPrice
            this.$set(this.carInfo.moParts,index,e)
          } else {
            e.purchasePriceUsd = e.unitPrice
            this.$set(this.carInfo.moParts,index,e)
          }
        }
      })
    },
    // 继续申请
    continueToApply(){
      location.reload(); //刷新当前页面
    },
    // 查看订单
    viewOrders(){
      this.$router.push("/Maintenance");
    },
    //取消申请
    cancelMyCo () {
      let params = 'coId=' + this.$route.query.id + '&remarks='
      cancelMyCo(params).then(res => {
        console.log(res,'取消申请');
        if(res.data.code==200){
          this.$message({
          message: 'success',
          type: 'success'
        });
        this.$router.go(0)
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    //取消
    cancel(){
      this.$router.push('/Maintenance')
    },
    
    getpartList(){
      this.amount=0
      let a = [...this.carInfo.moParts,...this.selectpart]
      
let map = new Map();
for (let item of a) {
    map.set(item.id, item);
 }
this.carInfo.moParts = [...map.values()]
    console.log(this.carInfo.moParts);
    
  
      // this.carInfo.moParts = [...this.carInfo.moParts,...this.selectpart]
      this.carInfo.moParts.forEach(e=>{
        this.amount = this.amount + Number(this.currency == 'CNY' ? e.purchasePriceCny : this.currency == 'EUR' ? e.purchasePriceEur : e.purchasePriceUsd) * Number(e.minPurchaseQuantity)
      })
      this.dialogVisiblePart = false
    },
    
    //添加配件
    addParts () {
          this.searchKey=''
      this.pageQueryPartList()
      this.dialogVisiblePart = true
    },
    async  pageQueryPartList () {
      let param = new URLSearchParams();
      let mcSeriesModelId 
      if(this.carInfo.co.params){
        mcSeriesModelId = this.carInfo.co.params.mcVersion.mcSeriesModel
      } else {
        
        mcSeriesModelId = this.carInfo.co.mcSeriesModelId
      }
      let searchKey =this.searchKey 
      const { data: res } = await pageQueryParta(
        param,
        1,
        100,
        mcSeriesModelId,
        searchKey
      );
      let a =[]
      res.data.list.forEach(z=>{
        if(z.deleted==false){
          a.push(z)
        }
      })
      this.partList = a
    },
    handleSelectionChange(val) {
      this.selectpart = val
    },
    
    pageQuerySa () {
      pageQuerySa().then(res => {

      })
    },
    //表头添加红色必填符号*
    renderHeader (h, { column, $index }) {
      return h(
        'div',
        [
          h('span', { style: 'color:red' }, '* '),
          h('span', column.label)
        ]
      )
    },
    async gbquerytype () {
      let param = new URLSearchParams();
      const { data: res } = await gbquerytype(param, 'sys_dealer_area/%20/', sessionStorage.getItem('userId'));
      this.gb = res.data
    },
    async gbquerytypea () {
      let param = new URLSearchParams();
      const { data: res } = await gbquerytype(param, 'sys_dealer/%20/', sessionStorage.getItem('userId'));
      this.jxc = res.data
    },
    bbca (e) {
      let a = ''
      let b = this.aeera
      b.forEach(z => {
        if (z.dictLabel == e) {
          a = z
        }
      })
      let bb = ''
      if (this.iszh == 'zh') {
        bb = a.dictLabel
      } else {
        bb = a.dictLabelEn
      }
      return bb
    },
    bbcaa (e) {
 
      
      let a = ''
      let b = this.gb
  
      b.forEach(z => {
        console.log(456456,z.dictCode,e);
        if (z.dictValue == e) {
          if (this.iszh == 'zh') {
        a = z.dictLabel
       
      } else {
        a = z.dictLabelEn
      }
        }
      })
    
     
      return a
    },
    async aeer () {
      let param = new URLSearchParams();
      const { data: res } = await querytype(param, 'area');
      this.aeera = res.data
    },
    beforeAvatarUpload(file){
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isLt2M;
    },
    uploadFile (file) {
      let formdata = new FormData()
      formdata.append('file', file.file)
      formdata.append('category', file.file.type)
      upload(formdata).then(res => {
        if (res.data.code == '200') {
          this.$message.success('上传成功')
          let obj = {
            name:file.file.name,
            url:res.data.data
          }
          this.fileList.push(obj)
        } else {
          this.$message.error('上传失败')
        }
      })
    },
    handleRemove(file, fileList) {
      this.fileList.forEach((e,i)=>{
        if(e.name == file.name){
          this.fileList.splice(i,1)
        }
      })
    },
    handlePictureCardPreview (file) {
      // if(file.url){
      //   this.filedialogImageUrl = file.url;
      // } else {
      //   this.fileList.filter(e=>e.name == file.file.name)[0].url
      // }
    },
    
    checkStaus(e){
      if(e == 10){
        return '待业务接收'
      } else if (e ==20){
        return '审核中'
      } else if (e ==29){
        return '审核中'
      } else if (e ==30){
        return '审核中'
      } else if (e ==39){
        return '审核中'
      } else if (e ==40){
        return '审核中'
      } else if (e ==49){
        return '审核中'
      } else if (e ==50){
        return '已通过'
      } else if (e ==59){
        return '已驳回'
      } else if (e ==60){
        return '已取消'
      } else {
        return e
      }
    },
    getQuerytype () {
      const params = new URLSearchParams()
      querytype( params, 't_co_claim_type').then(r => {
        if (r.data.code == 200) {
          r.data.data.forEach(i => {
            if (this.iszh !== 'zh') {
              i.dictLabel = i.dictLabelEn
            }
            this.titleList.push(i)
          })
        }
      })
      querytype( params, 't_co_fault_type').then(r => {
        if (r.data.code == 200) {
          r.data.data.forEach(i => {
            if (this.iszh !== 'zh') {
              i.dictLabel = i.dictLabelEn
            }
            this.titleLista.push(i)
          })
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.fullpage {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  .searchBox{
    display: flex;
    width: 100%;
    align-items: center;  
    :deep(.el-input){
      width: 400px;
      margin-right: 20px;
    }
  }

  .title {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #dcdfe6;
    margin: 10px 0;
    font-size: 18px;

    .name {
      border-left: 3px solid #409eff;
      padding-left: 10px;
      height: 22px;
      line-height: 22px;
    }
  }

  .basicInformation {
    width: 100%;
    margin-top: 20px;

    .Info {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-left: 10px;

      .infoItem {
        width: 30%;
        height: 70px;
        display: flex;
        flex-direction: column;

        .name {
        margin: 10px 0;
        color: #909399;
        }

        .infoData {}
      }
    }
  }

  .compensateInfo {
    width: 100%;
    margin-top: 20px;
    .beforeShowInfo{
      color: red;
      padding-left: 20px;
    }

    .infoItemOne {
      margin-top: 30px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-left: 10px;

      .infoItemOneItem {
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding-bottom: 20px;
        .name {
          margin: 10px 0;
          color: #909399;
        }

        .inputBox {
          width: 70%;
        }
      }
    }

    .infoItemTwo {
      width: 100%;
      padding-left: 10px;
      padding-bottom: 20px;

      .name {
        margin: 10px 0;
        color: #909399;
      }
    }
  }
/deep/.el-upload-list__item{
  width: fit-content;
}
  .compensateDetail {
    width: 100%;
    margin-top: 20px;

    .title {
      .nameList {
        border-left: 3px solid #409eff;
        padding-left: 10px;
        height: 22px;
        line-height: 22px;
        display: flex;

        .nameItem {
          margin-right: 40px;
          cursor: pointer;
        }

        .acti {
          color: #409eff;
        }
      }
    }

    .detail {
      width: 100%;
      padding-bottom: 30px;

      :deep(.el-upload-list__item.is-success .el-upload-list__item-status-label){ 
        position: static;
      }
      :deep(.el-upload-list__item){
        display: flex;
        align-items: center;
      }
      :deep(.el-icon-close){
        position: static;
      }

      .typeTitle {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
      }

      .uploadFiles {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        width: 300px;

        .bluecolor {
          color: #409eff;
        }

        .redcolor {
          color: red;
        }
      }
    }
  }

  .subBox {
    height: 60px;
    //border-top: 1px solid #dcdfe6;
    //border-bottom: 1px solid #dcdfe6;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .partBox {
    border-top: 1px solid #dcdfe6;
    padding: 20px;

    .searchBox {
      margin-bottom: 20px;

      /deep/.el-input {
        width: 50%;
      }

      /deep/.el-button {
        margin-left: 20px;
      }
    }

    .buttBox {
      width: 100%;
      text-align: center;
      padding: 30px;
    }

  }
  .img{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  :deep(.el-textarea__inner){
    font-family: inherit;
  }
}

/deep/.el-dialog__body {
  padding: 0 !important;
}
:deep(.el-upload-list.el-upload-list--picture) {
  display: none !important; //这里设置原有的缩略图视图隐藏
}

.el-upload-list.el-upload-list--picture.show {
  display: block !important; //展示自定义
}

</style>